// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"f6e0a6ec","200":"f6e0a6ec","249":"f6e0a6ec","433":"f6e0a6ec","708":"f6e0a6ec"}[chunkId] + ".chunk.css";
};